import React from 'react';
import { DefinitionOfReadyCriteria } from '../../../types';
import { Icon } from 'azure-devops-ui/Icon';
import remarkGfm from 'remark-gfm';
import ReactMarkdown from 'react-markdown';
import { ErrorBoundary } from 'react-error-boundary';

export interface IDefinitionOfReadyCriteriaProps {
  criteria: DefinitionOfReadyCriteria;
}

export default function DefinitionOfReadyCriteriaView(props: IDefinitionOfReadyCriteriaProps) {
  return (
    <div className='list-row flex-row h-scroll-hidden'>
      <div className='flex-row flex-center'>
        <Icon ariaLabel='Gripper Dots Vertical' iconName='GripperDotsVertical' />
      </div>
      <div
        style={{ marginLeft: '10px', padding: '10px 0px' }}
        className='flex-column h-scroll-hidden'
      >
        <span className='fontSizeMS font-size-ms secondary-text wrap-text'>
          <ErrorBoundary fallback={<span>{props.criteria}</span>}>
            <ReactMarkdown
              remarkPlugins={[remarkGfm]}
              components={{
                p: React.Fragment,
              }}
            >
              {props.criteria}
            </ReactMarkdown>
          </ErrorBoundary>
        </span>
      </div>
    </div>
  );
}
